import {
  ON_CONNECT,
  ON_CONNECT_BUSINESS,
  ON_TEXT_CHANGE,
  UPDATE_HASHTAG,
  SET_TEMPLATE_ACCOUNT,
} from '../../constants';
import WixService from './WixService';
import { getInstagramData } from './instagramService';
import { defaultInstaIds } from '../templates/templatesConfig.json';
import { _getCurrentDemoAccoundId } from './instagramUserAndMediasService';

const compId = WixService.getCompId();

/**
 * Update data of connected user
 * @param {Object} param - type = (ON_CONNECT_BUSINESS || ON_CONNECT)
 */
export const updateUserLoginData = ({
  type,
  accessToken,
  userId,
  expires_in,
  userDBData = {},
}) => (dispatch) => {
  dispatch({
    type,
    payload: {
      accessToken,
      userId,
      isConnected: true,
      expires_in,
      userDBData,
    },
  });
};

/**
 * Get Data from DB and update medias and user info (or template)
 */
export const getAccountData = () => (dispatch) => {
  const key = `settings${compId}`;
  WixService.getDataPublic(key).then((userData) => {
    console.log('userData', userData);
    userData = (userData && userData[key]) || userData;
    const instaToken =
      userData && (userData.in_access_token || userData.insta_access_token);
    const instaUserId =
      userData && (userData.in_u_id || userData.insta_user_id);
    const templateInstagramUserId = userData && userData.template_in_u_id;
    const isTemplate =
      !defaultInstaIds.includes(instaUserId) && instaToken && instaUserId
        ? false
        : true;
    // console.log('isTemplate in getAccountData', isTemplate);
    if (isTemplate) {
      let demoAccountId;
      if (defaultInstaIds.includes(instaUserId)) {
        demoAccountId = instaUserId;
        // console.log('demoAccountId1 in dataService', demoAccountId);
      } else {
        demoAccountId = _getCurrentDemoAccoundId(templateInstagramUserId);
        // console.log('demoAccountId2 in dataService', demoAccountId);
      }

      dispatch({
        type: SET_TEMPLATE_ACCOUNT,
        payload: demoAccountId,
      });
    } else {
      userData.isBusinessApp =
        userData?.isBusinessApp || userData?.expires_in === 'Never'
          ? true
          : false;
      dispatch(
        updateUserLoginData({
          type: userData.isBusinessApp ? ON_CONNECT_BUSINESS : ON_CONNECT,
          accessToken: userData.in_access_token || userData.insta_access_token,
          userId: userData.in_u_id || userData.insta_user_id,
          expires_in: userData.expires_in,
          userDBData: userData,
        }),
      );
      if (
        userData.loadMoreBtnText ||
        userData.followBtnText ||
        userData.hashtagTitleText
      ) {
        dispatch({
          type: ON_TEXT_CHANGE,
          payload: {
            loadMoreBtnText: userData.loadMoreBtnText || null,
            followBtnText: userData.followBtnText || null,
            hashtagTitleText: userData.hashtagTitleText || null,
          },
        });
      }

      if (userData.isBusinessApp) {
        dispatch({
          type: UPDATE_HASHTAG,
          payload: userData.hashtags,
        });
      }
    }

    dispatch(getInstagramData(isTemplate));
  });
};
